require('@babel/polyfill');
import axios from 'axios';

const UrlsHelper = require('JS/helpers/_urls')();
if (window.xReferer) {
    axios.defaults.headers.common['X-Referrer'] = window.xReferer;
}
axios.defaults.responseType = 'json';

const successStatusCode = 200;

const generateBaseEndPoint = (url) => {
  const campaignShortUrl = window.P2A.campaign.shortUrl;
  return `//${window.location.hostname}/app/${campaignShortUrl}/${url}`;
};

const transformResponse = (response) => {
    let json = response;

    try {
        json = JSON.parse(response);
    } catch (e) {}

    if (json.data) {
        try {
          json = JSON.parse(json.data);
        } catch (e) {
          json = json.data || {};
        }
    }
    return json;
}

const transformLegislatorResults = ( response) => {

    const transformedResponse = transformResponse(response);
    // The phone action legislator results don't have the data property set,
    // we need to set it here to stay consistent with the rest of actions
    // TODO:: change the backend to make sure that results for  the call action
    // are consistent with the rest of the actions
    const { email= [], twitter = [], phone = [], message = '' } = transformedResponse;
    let legislatorResults = { email, twitter, call: phone, errorMessage: message};
    if (legislatorResults.call.length) {
        legislatorResults.call[0].message = { id: "call" };
    }
    return legislatorResults;
}

const AxiosCreateAdvocate = axios.create({
    baseURL: generateBaseEndPoint('advocate'),
    // `transformResponse` allows changes to the response data to be made before
    // it is passed to then/catch
    transformResponse: [ data => { return transformResponse(data) }],
});

const AxiosCreatePreviews = axios.create({
    baseURL: generateBaseEndPoint('previews'),
    transformResponse: [ data => { return transformResponse(data) }],
});

const AxiosLegislatorResults = axios.create({
    baseURL: generateBaseEndPoint('legislators/search'),
    transformResponse: [ (data) => { return transformLegislatorResults(data) }],
    validateStatus: function (status) {
        return parseInt(status, 10) === successStatusCode;
    },
});

const AxiosLogCampaignClick = axios.create({
  baseURL: "/ajax/clicks/log"
});

const AxiosOneStepTakeAction = axios.create({
    baseURL: generateBaseEndPoint('action/oneStep'),
    transformResponse: [ (data) => { return transformResponse(data) }],
});

const AxiosGetSignatures = axios.create({
  baseURL: generateBaseEndPoint('signatures'),
  transformResponse: [ (data) => { return transformResponse(data) }],
});

const AxiosTakeAction = axios.create({
    baseURL: generateBaseEndPoint('action'),
    transformResponse: [ data => { return transformResponse(data) }],
});

const SocialApi = axios.create({
    baseURL: generateBaseEndPoint('social'),
    transformResponse: [ data => { return transformResponse(data) }],
});

const FindStakeholdersByAddress = axios.create({
  baseURL: generateBaseEndPoint("stakeholders/search/address"),
  transformResponse: [data => transformResponse(data)]
});

const FindStakeholdersByName = axios.create({
    baseURL: generateBaseEndPoint("stakeholders/search/name"),
    transformResponse: [data => transformResponse(data)]
});

const CreateStakeholderRelationship = axios.create({
    baseURL: generateBaseEndPoint("stakeholders/relationship"),
    transformResponse: [data => transformResponse(data)]
});

export {
    AxiosGetSignatures,
    AxiosCreateAdvocate, 
    AxiosCreatePreviews, 
    AxiosLegislatorResults, 
    AxiosOneStepTakeAction, 
    AxiosTakeAction, 
    FindStakeholdersByAddress, 
    FindStakeholdersByName, 
    AxiosLogCampaignClick,
    CreateStakeholderRelationship,
    SocialApi 
};
